// @needsAudit
/**
 * Options passed to `makeRedirectUri`.
 */ export { };

//# sourceMappingURL=AuthSession.types.js.map
